<template>
  <v-sheet
    class="px-3 mx-auto"
    color="transparent"
    max-width="960px"
    width="100%"
  >
    <v-overlay :value="isLoadingInsert">
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>

    <template v-if="isLoading">
      <v-card class="mt-6 mt-sm-7 form-card">
        <div class="d-flex align-center">
          <v-progress-circular indeterminate size="20" color="red" />

          <div class="text-h6 font-weight-medium ml-3">Carregando...</div>
        </div>
      </v-card>
    </template>

    <template v-else>
      <TitleFormWidget class="mt-6" icon="account" :title="title" />

      <v-form @submit.prevent="submit" class="mt-3 mt-sm-4" ref="form">
        <v-card class="form-card">
          <div class="grid-list grid-list-4-columns">
            <TextFarmField
              v-model="people.name"
              class="span2"
              placeholder="Nome Completo"
              title="Nome"
            />

            <TextFarmField
              v-model="people.cpf_cnpj"
              @input="people.cpf_cnpj = maskCpfCnpj(people.cpf_cnpj)"
              title="CPF/CNPJ"
              maxlength="18"
              only-number
            />

            <TextFarmField
              v-model="people.phone"
              @input="people.phone = maskPhone(people.phone)"
              placeholder="(00) 00000-0000"
              title="Telefone"
              maxlength="15"
              only-number
            />

            <TextFarmField
              v-model="people.email"
              placeholder="email@exemplo.com.br"
              title="E-mail"
            />

            <BooleanFarmField v-model="people.is_owner" title="Proprietário" />
            <BooleanFarmField v-model="people.is_captivator" title="Captador" />

            <TextFarmField
              v-if="people.is_captivator"
              v-model="people.creci"
              title="CRECI"
            />

            <TextareaFarmField
              v-model="people.observation"
              class="span4"
              title="Observações"
              no-resize
            />
          </div>
        </v-card>

        <v-sheet class="mt-6 mt-sm-8 fixed-bottom" color="#f7f8fa">
          <v-divider />

          <div class="d-flex justify-end py-4 px-6">
            <v-btn
              @click="dialogToGoBack = !dialogToGoBack"
              class="rounded-lg"
              color="#dddddd"
              outlined
            >
              <v-icon color="black" size="20">mdi-undo-variant</v-icon>
              <div
                class="black--text text-body-1 text-none font-weight-medium ml-2"
              >
                Voltar
              </div>
            </v-btn>

            <v-btn
              class="rounded-lg ml-2"
              color="orange"
              type="submit"
              depressed
            >
              <v-icon color="white" size="20">mdi-content-save</v-icon>
              <div
                class="white--text text-body-1 text-none font-weight-medium ml-2"
              >
                {{ itemId ? "Atualizar" : "Salvar" }}
              </div>
            </v-btn>
          </div>
        </v-sheet>
      </v-form>
    </template>

    <v-dialog
      v-if="dialogToGoBack"
      v-model="dialogToGoBack"
      max-width="500"
      persistent
    >
      <ToGoBackDialog @close="dialogToGoBack = !dialogToGoBack" />
    </v-dialog>
  </v-sheet>
</template>

<script>
import TitleFormWidget from "@/components/widgets/TitleForm.vue";
import TextFarmField from "@/components/fields/farm/Text.vue";
import BooleanFarmField from "@/components/fields/farm/Boolean.vue";
import TextareaFarmField from "@/components/fields/farm/Textarea.vue";
import ToGoBackDialog from "@/components/dialogs/ToGoBack.vue";
import maskCpfCnpj from "@/utils/maskCpfCnpj";
import maskPhone from "@/utils/maskPhone";
import { mapActions } from "vuex";

export default {
  components: {
    TitleFormWidget,
    TextFarmField,
    BooleanFarmField,
    TextareaFarmField,
    ToGoBackDialog,
  },
  data: () => ({
    isLoading: false,
    people: {
      name: null,
      cpf_cnpj: null,
      phone: null,
      email: null,
      creci: null,
      observation: null,
      is_owner: null,
      is_captivator: null,
    },
    isLoadingInsert: false,
    dialogToGoBack: false,
  }),
  computed: {
    itemId() {
      return this.$route.params.id || null;
    },
    title() {
      if (this.people.name && this.people.name?.length > 2)
        return this.people.name;

      return !this.itemId ? "Novo Cadastro" : this.people.name;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    ...mapActions("peoples", ["getPeople", "insertPeople", "updatePeople"]),
    async submit() {
      this.isLoadingInsert = true;

      const form = new FormData();

      for (let item in this.people) {
        if (this.people[item] || this.people[item] == 0) {
          form.append(item, this.people[item]);
        }
      }

      const action = this.itemId ? this.updatePeople : this.insertPeople;
      const r = await action.call(this, form);

      if (r) {
        this.$eventHub.$emit("snackBar", {
          icon: "mdi-account-plus",
          message: `${
            this.itemId ? "Atualização realizada" : "Cadastro realizado"
          } com sucesso.`,
          type: "success",
        });

        this.$router.push({ path: "/cadastro" });
      } else {
        this.$eventHub.$emit("snackBar", {
          icon: "mdi-alert-circle",
          message: `Erro ao ${
            this.itemId ? "atualizar" : "cadastrar"
          }. Tente novamente.`,
          type: "error",
        });
      }

      this.isLoadingInsert = false;
    },
    async onLoad() {
      if (!this.itemId) return;

      this.isLoading = true;
      this.people = await this.getPeople(this.itemId);

      if (this.people.cpf_cnpj)
        this.people.cpf_cnpj = this.maskCpfCnpj(this.people.cpf_cnpj);

      if (this.people.phone)
        this.people.phone = this.maskPhone(this.people.phone);
      this.isLoading = false;
    },
    maskCpfCnpj,
    maskPhone,
  },
  created() {
    this.onLoad();
  },
};
</script>

<style lang="scss" scoped>
.form-card {
  border: 1px solid #e5e5e5 !important;
  border-radius: 14px !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1) !important;
  padding: 24px;
}

.grid-list {
  display: grid;
  gap: 12px;
}

.grid-list-4-columns {
  grid-template-columns: repeat(4, 1fr);
}

.span2 {
  grid-column: span 2;
}

.span3 {
  grid-column: span 3;
}

.span4 {
  grid-column: span 4;
}

.fixed-bottom {
  bottom: 0;
  margin-left: -12px;
  margin-right: -12px;
  position: sticky;
}
</style>
